import { render } from "./ChartsBorderConfiger.vue?vue&type=template&id=3b9df227&scoped=true"
import script from "./ChartsBorderConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsBorderConfiger.vue?vue&type=script&lang=js"

import "./ChartsBorderConfiger.vue?vue&type=style&index=0&id=3b9df227&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9df227"]])

export default __exports__